export default "__VITE_ASSET__a7ae92fc__"